var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"force-email-checkbox",class:{disabled: _vm.shouldDisable()}},[_c('Checkbox',{attrs:{"name":_vm.name,"disabled":_vm.shouldDisable(),"id":_vm.name,"onChange":function (val) { this$1.isChecked = val }},on:{"checkEmails":_vm.checkEmails}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }